import { UserRound } from 'lucide-react'

import { cn } from '@/lib/utils'

/** Max decorative worker icons drawn; the number beside them stays exact. */
export const WORKER_ICON_CAP = 100

interface WorkerGlyphsProps {
  /** Whole workers. Rounded by the caller, so the glyph count matches the
   *  printed number. */
  workers: number
  className?: string
}

/** The row of person glyphs that stands in for the full-time-worker estimate.
 *
 *  Shared by the org home card and the duty-metrics overview strip so the two
 *  cannot drift — the cap in particular, which exists because a high-usage org
 *  would otherwise render thousands of DOM nodes.
 */
export function WorkerGlyphs({ workers, className }: WorkerGlyphsProps) {
  return (
    <div
      className={cn(
        'flex min-w-0 flex-1 gap-1 overflow-hidden text-slate-300 dark:text-slate-600',
        className
      )}
      aria-label={`${workers} full time workers`}>
      {Array.from({ length: Math.min(workers, WORKER_ICON_CAP) }).map(
        (_, i) => (
          <UserRound key={i} className="size-5 shrink-0" aria-hidden />
        )
      )}
    </div>
  )
}
